import { render, staticRenderFns } from "./popup-credits.vue?vue&type=template&id=c9c2ed3c&scoped=true&"
import script from "./popup-credits.vue?vue&type=script&lang=js&"
export * from "./popup-credits.vue?vue&type=script&lang=js&"
import style0 from "./popup-credits.vue?vue&type=style&index=0&id=c9c2ed3c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c2ed3c",
  null
  
)

export default component.exports